import { useTranslations } from 'next-intl';
import cx from 'classnames';
import { CatHeading } from 'components/blocks-components';
import NoEquipmentSelected from '../../no-equipment-selected/no-equipment-selected';
import { Image } from 'components/image';
import { WIDGET_IMAGE } from '../constants';
import styles from './no-equipment.module.scss';

const NoEquipmentWrapper = ({
  hasEquipmentsToSelect
}: {
  hasEquipmentsToSelect: boolean;
}) => {
  const t = useTranslations();
  const { src, width, height } = WIDGET_IMAGE;

  return (
    <>
      <div className={cx('d-flex pb-3', styles['no-equipment-wrapper'])}>
        <Image
          src={src}
          alt={t('ADD_SELECT_EQP')}
          width={width}
          height={height}
        />
        <div>
          <CatHeading variant="title-sm" className="text-break">
            {hasEquipmentsToSelect
              ? t('SELECT_EQUIPMENT')
              : t('GA_LABEL_ADD_EQUIPMENT')}
          </CatHeading>
          <CatHeading variant="footnote">{t('MEQ_PARTS_FIT_CTA')}</CatHeading>
        </div>
      </div>
      <NoEquipmentSelected
        onlyRenderButton
        hasEquipmentsToSelect={hasEquipmentsToSelect}
      />
    </>
  );
};
export default NoEquipmentWrapper;
